import { BulkCreateCompanyWizardProvider } from "../components/BulkCreateCompanyWizardProvider";
import { BulkCreateCompanyWizardStepper } from "../components/BulkCreateCompanyWizardStepper";
import s from "./BulkCreateCompanyLayout.module.css";

/**
 * Wizard shell for the bulk company-creation flow
 * (`/onboarding/bulk-create-company/*`) — nested inside `CompanyConfigLayout`
 * (which gates on `enable-company-config`) and `OnboardingLayout` (workspace
 * shell + `enable-onboarding`). This layout only adds the step indicator and
 * shared wizard state (via `BulkCreateCompanyWizardProvider`, which renders
 * the active step through its own `<Outlet />`).
 */
export function BulkCreateCompanyLayout() {
  return (
    <div className={s.container}>
      <BulkCreateCompanyWizardStepper />
      <BulkCreateCompanyWizardProvider />
    </div>
  );
}
